module.exports = __webpack_public_path__ + "img/icon-check.15fc0d79.svg";